<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import { BFormSelect } from 'bootstrap-vue-next';

const instance = getCurrentInstance();
const proxy = instance?.proxy as any;
const root = proxy?.$root;
const $app = computed(() => root?.$app);

const options = computed(() => {
  const locales = $app.value?.i18n?.getLocales() || [];
  return locales.map((loc: { code: string; name: string }) => ({
    value: loc.code,
    text: loc.name,
  }));
});

const localeCode = computed({
  get: () => $app.value?.i18n?.locale || '',
  set: (value: string) => {
    $app.value?.i18n?.setLocale(value);
  },
});
</script>

<template>
  <BFormSelect
    v-model="localeCode"
    :options="options"
    size="sm"
    @click.stop
    @mousedown.stop
  />
</template>

